import { Equipment } from './equipment';

export class Appraisal {
  public id;
  public returnReason;
  public description;
  public reusable;
  public os;
  public jiraTicket;
  public telecomProvider;
  public invoiceNumber;
  public comment;
  public entryDate;
  public appraisalDate;
  public branch;
  public equipmentType;
  public equipment: Equipment;
  public files;
  public access;
  public appraisalTests;
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/appraisal.ts